module.exports = __webpack_public_path__ + "static/img/zhongzhongka6.afa6186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka6.png
// module id = 177K
// module chunks = 16